/* LabCharge bundle offer section (lc-offer). No dependencies. */
(function () {
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    // Some stores/currency apps wrap the format in HTML (e.g. <span class=money>). Strip it for plain-text use.
    format = String(format || '${{amount}}').replace(/<[^>]*>/g, '').trim() || '${{amount}}';
    function delimit(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        default: return delimit(cents, 2, ',', '.');
      }
    });
  }

  function init(root) {
    if (root.dataset.lcReady) return;
    root.dataset.lcReady = '1';

    var cfgEl = root.querySelector('[data-lc-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { bonuses: {}, media: {} };
    var money = function (c) { return formatMoney(c, cfg.moneyFormat); };
    var B = cfg.bonuses || {};
    var KEYS = ['ship', 'warranty', 'plug', 'ionic'];

    var tierEls = Array.prototype.slice.call(root.querySelectorAll('.tier'));
    var tiers = tierEls.map(function (el) {
      var d = el.dataset;
      return {
        el: el,
        input: el.querySelector('input[type=radio]'),
        label: d.label,
        price: +d.price,
        compare: +d.compare,
        units: +d.units || 1,
        bonuses: (d.bonuses || '').split(',').filter(Boolean),
        media: d.mediaId,
        available: d.available === 'true'
      };
    });
    if (!tiers.length) return;

    var $ = function (sel) { return root.querySelector(sel); };
    var qtyInput = root.querySelector('input[name=quantity]');
    var ctas = root.querySelectorAll('[data-cta]');
    var current = -1;

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function save(t) { return t.compare > t.price ? t.compare - t.price : 0; }

    function setMedia(id) {
      if (!id || !cfg.media || !cfg.media[id]) return;
      var main = root.querySelector('.main-img img');
      if (main) { main.removeAttribute('srcset'); main.src = cfg.media[id]; }
      root.querySelectorAll('.thumb').forEach(function (t) { t.classList.toggle('on', t.dataset.mediaId === String(id)); });
    }

    function toast(keys) {
      var el = $('[data-toast]');
      if (!el) return;
      $('[data-toast-imgs]').innerHTML = keys.filter(function (k) { return B[k] && B[k].img; })
        .map(function (k) { return '<img src="' + B[k].img + '" alt="">'; }).join('');
      $('[data-toast-txt]').textContent = '🔓 Unlocked: ' + keys.map(function (k) { return B[k] ? B[k].n : k; }).join(' + ');
      el.classList.add('show');
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.classList.remove('show'); }, 2400);
    }

    function render(quiet) {
      var i = current, t = tiers[i], q = qty();
      var prev = root._prevBonuses || [];

      tiers.forEach(function (x, k) { x.el.classList.toggle('sel', k === i); });

      // Ladder
      var fill = $('[data-fill]');
      if (fill) fill.style.width = (t.bonuses.length / KEYS.length * 100) + '%';
      var fresh = [];
      root.querySelectorAll('.bonus').forEach(function (el) {
        var k = el.dataset.b, on = t.bonuses.indexOf(k) > -1;
        if (on && prev.indexOf(k) === -1) {
          fresh.push(k);
          el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
        }
        el.classList.toggle('on', on);
      });
      root._prevBonuses = t.bonuses.slice();

      var next = tiers[i + 1];
      var msg = $('[data-ladder-msg]');
      if (msg) {
        if (next) {
          var add = next.bonuses.filter(function (b) { return t.bonuses.indexOf(b) === -1; })
            .map(function (b) { return B[b] ? B[b].n : b; });
          msg.textContent = add.length ? '🔓 Go to ' + next.label + ' to unlock ' + add.join(' + ') : '🔓 ' + next.label + ' lowers your price per unit';
          msg.classList.remove('max');
        } else {
          msg.textContent = '🎉 All bonuses unlocked!';
          msg.classList.add('max');
        }
      }

      // Nudge
      var nudge = $('[data-nudge]');
      if (nudge) {
        if (next) {
          var diff = next.price - t.price;
          var moreUnits = next.units - t.units;
          var newB = next.bonuses.filter(function (b) { return t.bonuses.indexOf(b) === -1; })
            .map(function (b) { return B[b] ? B[b].n : b; });
          var parts = [];
          if (moreUnits > 0) parts.push(moreUnits + ' more purifier' + (moreUnits > 1 ? 's' : ''));
          if (newB.length) parts.push('<b>' + newB.join(' + ') + '</b>');
          nudge.innerHTML = 'For <b>' + money(diff) + ' more</b>, ' + next.label + ' gets you ' + parts.join(' plus ') + '.';
        } else {
          var gifts = t.bonuses.filter(function (b) { return b === 'plug' || b === 'ionic'; }).length;
          nudge.innerHTML = '<b>Best value:</b> ' + money(t.price / t.units) + ' per purchased unit' + (gifts ? ', plus ' + gifts + ' FREE purifier' + (gifts > 1 ? 's' : '') + ' on top.' : '.');
        }
      }

      // CTA + sticky
      var total = t.price * q;
      var sub = $('[data-cta-sub]');
      if (sub) sub.textContent = t.label + (q > 1 ? ' × ' + q : '') + ': ' + money(total);
      ctas.forEach(function (b) { b.disabled = !t.available; });
      if (!t.available && sub) sub.textContent = 'Sold out';

      var stTotal = $('[data-st-total]'), stWas = $('[data-st-was]'), stSave = $('[data-st-save]');
      if (stTotal) stTotal.textContent = money(total);
      var sv = save(t);
      if (stWas && stSave) {
        if (sv > 0) {
          stWas.textContent = money(t.compare * q); stWas.hidden = false;
          stSave.textContent = 'SAVE ' + money(sv * q) + (t.bonuses.indexOf('ship') > -1 ? ' · FREE ship' : '');
          stSave.classList.remove('up');
        } else {
          stWas.hidden = true;
          var better = tiers.slice(i + 1).filter(function (x) { return save(x) > 0; })[0];
          if (better) { stSave.textContent = better.label + ' saves ' + money(save(better)) + ' ↑'; stSave.classList.add('up'); }
          else { stSave.textContent = t.label; stSave.classList.remove('up'); }
        }
      }

      if (fresh.length && !quiet) toast(fresh);
    }

    function select(i, quiet) {
      if (i < 0 || i >= tiers.length) return;
      var t = tiers[i];
      if (!t.available) return;
      current = i;
      t.input.checked = true;
      if (!quiet) setMedia(t.media);
      render(quiet);
      // keep ?variant= in sync so a shared link opens the same bundle
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', t.input.value);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    tiers.forEach(function (t, i) {
      t.input.addEventListener('change', function () { if (t.input.checked) select(i); });
    });

    // Quantity
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var max = parseInt(qtyInput.max, 10) || 99;
        qtyInput.value = Math.min(max, Math.max(1, qty() + parseInt(btn.dataset.qty, 10)));
        render(true);
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', function () { render(true); });

    // Lets other LabCharge sections (gifts, closing CTA) pick a bundle by variant id or "last"
    root._pick = function (v) {
      if (v === 'last') return select(tiers.length - 1);
      var i = tiers.findIndex(function (t) { return t.input.value === String(v); });
      if (i > -1) select(i);
    };

    // Gallery thumbnails
    root.querySelectorAll('.thumb').forEach(function (th) {
      th.addEventListener('click', function () {
        var main = root.querySelector('.main-img img');
        if (main) { main.removeAttribute('srcset'); main.src = th.dataset.src; }
        root.querySelectorAll('.thumb').forEach(function (x) { x.classList.toggle('on', x === th); });
      });
    });

    // Sticky bar shows once the main button scrolls away
    var sticky = $('[data-sticky]'), mainCta = root.querySelector('.cta-box [data-cta]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle('show', !e[0].isIntersecting); }).observe(mainCta);
    }

    // Countdown
    var timer = root.querySelector('[data-deadline]');
    if (timer) {
      var end = new Date(timer.dataset.deadline);
      var pad = function (n) { return String(Math.floor(n)).padStart(2, '0'); };
      var tick = function () {
        var d = Math.max(0, end - new Date()) / 1000;
        timer.querySelector('[data-t=d]').textContent = pad(d / 86400);
        timer.querySelector('[data-t=h]').textContent = pad(d % 86400 / 3600);
        timer.querySelector('[data-t=m]').textContent = pad(d % 3600 / 60);
        timer.querySelector('[data-t=s]').textContent = pad(d % 60);
      };
      tick(); setInterval(tick, 1000);
    }

    // Initial state from the server-checked radio
    var start = tiers.findIndex(function (t) { return t.input.checked; });
    if (start < 0) start = tiers.findIndex(function (t) { return t.available; });
    if (start < 0) start = 0;
    current = start;
    root._prevBonuses = tiers[start].bonuses.slice();
    render(true);
  }

  function boot() { document.querySelectorAll('.lc-offer--main').forEach(init); }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lc-pick]');
    if (!a) return;
    var main = document.querySelector('.lc-offer--main');
    if (main && main._pick) main._pick(a.dataset.lcPick);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-init when the section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.lc-offer--main'); if (el) init(el);
  });
})();